import { useState, useEffect, forwardRef } from "react";
import { ArrowUp } from "lucide-react";
import { motion, AnimatePresence } from "@/components/motion";

const MotionButton = motion(
  forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(
    (props, ref) => <button ref={ref} {...props} />
  )
);

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <MotionButton
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-24 right-6 z-40 w-11 h-11 rounded-full bg-accent text-accent-foreground shadow-lg flex items-center justify-center hover:brightness-110 transition"
          aria-label="Back to top"
        >
          <ArrowUp className="w-5 h-5" />
        </MotionButton>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;
